import { Alert, Card, Form, Table } from "react-bootstrap";
import { DatagridHelper } from "../../datagrid/DatagridHelper";
import { DataType, MessageType, ResponseStatus } from "../../utils/types";
import Loading from "../../utils/Loding";
import { CampaignsResponseDto } from "../../utils/types";
import { CampaignsResponseDtoCampaign } from "../../utils/types";
import { CampaignsResponseDtoUnconfiguredCampaign } from "../../utils/types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleCheck, faCircleExclamation, faTriangleExclamation } from "@fortawesome/free-solid-svg-icons";

interface CampaignsTableProps {
  campaignsResponseDto: CampaignsResponseDto;
  setCampaignsResponseDto: (campaignsResponseDto:CampaignsResponseDto) => void;
  unconfigured?: boolean;
  headerTitle?: string;
  setCampaignsAreDirty?: (campaignsAreDirty: boolean) => void;
}

const cardHeaderStyle = {
  fontWeight: "bold",
  fontSize: "1.2rem"
}

function CampaignsTable(props:CampaignsTableProps) {
  const { campaignsResponseDto, setCampaignsResponseDto, unconfigured, headerTitle, setCampaignsAreDirty } = props;

  if (campaignsResponseDto && campaignsResponseDto.status === ResponseStatus.LOADING) return <Loading />;
  if (!campaignsResponseDto || campaignsResponseDto.status === ResponseStatus.ERROR) {
    return (
      <Alert variant={MessageType.DANGER}>
        <span>{campaignsResponseDto && campaignsResponseDto.error ? campaignsResponseDto.error : "Error loading campaigns"}</span>
      </Alert>
    );
  }

  const handleSelectCampaign = (index:number, isUnconfigured:boolean ,checked:boolean) => {
    const unconfiguredCampaigns:CampaignsResponseDtoUnconfiguredCampaign[] = isUnconfigured ? campaignsResponseDto.unconfiguredCampaigns.map((campaign, cIndex) => index === cIndex ? { ...campaign, added: checked } : campaign) : campaignsResponseDto.unconfiguredCampaigns;
    const campaigns:CampaignsResponseDtoCampaign[] = !isUnconfigured ? campaignsResponseDto.campaigns.map((campaign, cIndex) => index === cIndex ? { ...campaign, added: checked } : campaign) : campaignsResponseDto.campaigns;

    setCampaignsResponseDto({ ...campaignsResponseDto, campaigns, unconfiguredCampaigns });
    if (setCampaignsAreDirty) {
      setCampaignsAreDirty(true);
    }
  }

  return (
    <Card>
      <Card.Header style={cardHeaderStyle}>{headerTitle ? headerTitle : "Campaigns"}</Card.Header>
      <Table style={{ fontSize: 11 }} responsive striped bordered hover>
        {
          (unconfigured) ?
          <>
            <thead>
              <tr>
                <th>Source</th>
                <th>Campaign ID</th>
                <th>Include Campaign</th>
              </tr>
            </thead>
            <tbody>
              {
                campaignsResponseDto.unconfiguredCampaigns.map((campaign, index:number) => {
                  return (
                    <tr key={index} className="{{campaign.source}}">
                      <td>
                        <span data-tooltip="{{campaign.source}}">
                          {campaign.source}
                        </span>
                      </td>
                      <td>
                        <span data-tooltip="{{campaign.campaign_id}}">
                          {campaign.campaign_id}
                        </span>
                      </td>
                      <td style={{ textAlign: "center" }}> 
                        <Form.Check
                          inline
                          type="checkbox"
                          checked={campaign.added}
                          disabled={campaignsResponseDto.unconfiguredCampaigns.find((c) => c.added && c.incent !== campaign.incent) !== undefined}
                          onChange={(e) => handleSelectCampaign(index, true, e.target.checked)}
                        />
                      </td>
                    </tr>
                  );
                })
              }
            </tbody>
          </>
          :
          <>
            <thead>
              <tr>
                <th>Status</th>
                <th>Source</th>
                <th>CampaignID</th>
                <th>Countries</th>
                <th>Limit</th>
                <th>Payout</th>
                <th>Platforms</th>
                <th>OS Version</th>
                <th>End Date</th>
                <th>DeviceID Required</th>
                <th>Allow Incent</th>
                <th style={{ textAlign: "center" }}>Include Campaign</th>
              </tr>
            </thead>
            <tbody>
              {
                campaignsResponseDto.campaigns.map((campaign, index:number) => {
                  return (
                    <tr key={index} className="{{campaign.status}}">
                      <td>
                        <span data-tooltip="{{campaign.status}}">
                          <div title={campaign.status} style={{ display: "inline-block", marginRight: "0.3rem" }}>
                            {(() => {
                              if (campaign.status === 'ACTIVE') {
                                return <FontAwesomeIcon icon={faCircleCheck} style={{color: "#5cb85c"}}/>
                              } else if (campaign.status === 'PAUSED') {
                                return <FontAwesomeIcon icon={faCircleExclamation} />;
                              } else {
                                return <FontAwesomeIcon icon={faTriangleExclamation} style={{color: "#ed9c28"}} />;
                              }
                            })()}
                          </div>
                          {campaign.status}
                        </span>
                      </td>
                      <td>
                        <span data-tooltip="{{campaign.supplySource}}">
                          {campaign.supplySource}
                        </span>
                      </td>
                      <td>
                        <span data-tooltip="{{campaign.campaignID}}">
                          {campaign.campaignID}
                        </span>
                      </td>
                      <td>
                        <span data-tooltip="{{campaign.countries}}">
                          {campaign.countries}
                        </span>
                      </td>
                      <td>
                        <span data-tooltip="{{campaign.limit}}">
                          {campaign.limit}
                        </span>
                      </td>
                      <td>
                        <span data-tooltip="{{campaign.payout}}">
                          {DatagridHelper.formatValue(DataType.MONEY, Number(campaign.payout))}
                        </span>
                      </td>
                      <td>
                        <span data-tooltip="{{campaign.platforms}}">
                          {campaign.platforms}
                        </span>
                      </td>
                      <td>
                        <span data-tooltip="{{campaign.osVersion}}">
                          {campaign.osVersion}
                        </span>
                      </td>
                      <td>
                        <span data-tooltip="{{campaign.enddate}}">
                          {campaign.enddate}
                        </span>
                      </td>
                      <td>
                        <span data-tooltip="{{campaign.deviceIDRequired}}">
                          {campaign.deviceIDRequired.toString()}
                        </span>
                      </td>
                      <td>
                        <span data-tooltip="{{campaign.incent}}">
                          {campaign.incent.toString()}
                        </span>
                      </td>
                      <td style={{ textAlign: "center" }}> 
                        <Form.Check
                          inline
                          type="checkbox"
                          checked={campaign.added}
                          disabled={campaignsResponseDto.campaigns.find((c) => c.added && c.incent !== campaign.incent) !== undefined}
                          onChange={(e:any) => handleSelectCampaign(index, false, e.target.checked)}
                        />
                      </td>
                    </tr>
                  );
                })
              }
            </tbody>
          </>
        }
      </Table>
    </Card>
  );
}

export default CampaignsTable;